module.exports = __webpack_public_path__ + "static/img/headlogo.a7edd64.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/headlogo.jpg
// module id = QYjr
// module chunks = 1